package es.cragma.fichajefacil.data

import es.cragma.fichajefacil.model.Company
import es.cragma.fichajefacil.model.ClockInRecord
import es.cragma.fichajefacil.model.User

expect fun platformSyncCompanyToCloud(company: Company)
expect fun platformSyncEmployeeToCloud(user: User)
expect fun platformSyncClockInToCloud(record: ClockInRecord)
expect fun platformFetchCloudData(onLoaded: (companiesJson: String, usersJson: String) -> Unit)
expect fun platformRegisterCompanyAndAdmin(company: Company, adminUser: User, password: String)
expect fun platformFetchUserAccountsFromCloud(
    email: String,
    onResult: (usersAndCompanies: List<Pair<User, Company?>>, clockIns: List<ClockInRecord>) -> Unit
)

object FirestoreSyncManager {
    fun fetchUserAccountsFromCloud(
        email: String,
        onResult: (usersAndCompanies: List<Pair<User, Company?>>, clockIns: List<ClockInRecord>) -> Unit
    ) {
        try {
            platformFetchUserAccountsFromCloud(email, onResult)
        } catch (e: Throwable) {
            println("Fetch user accounts error: ${e.message}")
            onResult(emptyList(), emptyList())
        }
    }

    fun syncCompanyToCloud(company: Company) {
        try {
            platformSyncCompanyToCloud(company)
        } catch (e: Throwable) {
            println("Sync company error: ${e.message}")
        }
    }

    fun syncEmployeeByEmailToCloud(user: User) {
        try {
            platformSyncEmployeeToCloud(user)
        } catch (e: Throwable) {
            println("Sync employee error: ${e.message}")
        }
    }

    fun syncClockInToCloud(record: ClockInRecord) {
        try {
            platformSyncClockInToCloud(record)
        } catch (e: Throwable) {
            println("Sync clockIn error: ${e.message}")
        }
    }

    fun fetchCloudData(onLoaded: (companiesJson: String, usersJson: String) -> Unit) {
        try {
            platformFetchCloudData(onLoaded)
        } catch (e: Throwable) {
            println("Fetch cloud data error: ${e.message}")
        }
    }

    fun registerCompanyAndAdmin(company: Company, adminUser: User, password: String) {
        try {
            platformRegisterCompanyAndAdmin(company, adminUser, password)
        } catch (e: Throwable) {
            println("Register company error: ${e.message}")
        }
    }
}
